// extracted by mini-css-extract-plugin
export default {"visionMission":"VisionMission_visionMission__2J6HT","section":"VisionMission_section__dI9Ua","twoColumn":"VisionMission_twoColumn__Kw7pj"};